module.exports = __webpack_public_path__ + "static/RR1-355544c928ef917f798ab1735f2ab61e.jpg";